import { Helmet } from 'react-helmet-async';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { pagesApi } from '../lib/api';
import ReactMarkdown from 'react-markdown';

export function DynamicPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: page, isLoading, error } = useQuery({
    queryKey: ['page', slug],
    queryFn: () => pagesApi.getBySlug(slug!).then((res) => res.data),
    enabled: !!slug,
  });

  if (isLoading) {
    return <div className="container-custom py-12 text-center">Yükleniyor...</div>;
  }

  if (error || !page) {
    return (
      <div className="container-custom py-12 text-center">
        <h1 className="text-2xl font-bold mb-4">Sayfa bulunamadı</h1>
        <Link to="/" className="btn btn-primary">
          Ana Sayfaya Dön
        </Link>
      </div>
    );
  }

  if (!page.isActive) {
    return (
      <div className="container-custom py-12 text-center">
        <h1 className="text-2xl font-bold mb-4">Bu sayfa şu anda aktif değil</h1>
        <Link to="/" className="btn btn-primary">
          Ana Sayfaya Dön
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{page.metaTitle || page.title} - {import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'}</title>
        <meta name="description" content={page.metaDesc || page.title} />
      </Helmet>

      {/* Hero Section with Image */}
      {page.imageUrl && (
        <div className="relative w-full h-[400px] md:h-[500px] overflow-hidden bg-gray-200">
          <img
            src={page.imageUrl}
            alt={page.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 container-custom pb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg">
              {page.title}
            </h1>
          </div>
        </div>
      )}

      {/* Content Section */}
      <div className="container-custom py-12 md:py-16">
        {!page.imageUrl && (
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {page.title}
            </h1>
            <div className="w-24 h-1 bg-primary-600 mx-auto" />
          </div>
        )}

        {/* Main Content */}
        <div className="max-w-4xl mx-auto">
          <div className="about-content">
            {page.content && <ReactMarkdown>{page.content}</ReactMarkdown>}
          </div>
        </div>
      </div>
    </>
  );
}

